<template>
	<div>
		<p style="font-size: 50px;margin-top: 150px;">{{ $t('lang.regist1')}}</p>
		<div style="width: 800px;margin-bottom: 30px;text-align: right;position: relative;right: 200px;" class="center_sun">
			<label style="margin-bottom: 30px;"><span class="span">{{ $t('lang.regist2')}}</span></label>
			<input style="margin-bottom: 30px;" v-model="name" class="input" :placeholder="$t('lang.regist3')" autocomplete="off">
			<br />
			<label style="margin-bottom: 30px;"><span class="span">{{ $t('lang.regist4')}}</span></label>
			<input style="margin-bottom: 30px;" v-model="tel" class="input" :placeholder="$t('lang.regist5')" autocomplete="off">
			<br />
			<label style="margin-bottom: 30px;"><span class="span">{{ $t('lang.regist6')}}</span></label>
			<input style="margin-bottom: 30px;" v-model="mail" class="input" :placeholder="$t('lang.regist7')" autocomplete="off">
			<br />
			<label style="margin-bottom: 30px;vertical-align: top;"><span class="span">{{ $t('lang.regist8')}}</span></label>
			<textarea :placeholder="$t('lang.regist10')" style="margin-bottom: 30px;width: 350px;font-size: 20px;" v-model="text" rows="5" cols="40"></textarea>
		</div>
		<button style="width: 400px;height: 50px;" @click="onSubmit()" class="span button">{{ $t('lang.regist9')}}</button>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tel:'',
				name: '',
				mail:'',
				text:'',
			};
		},
		methods: {
			onSubmit(){
				if(this.tel == "" && this.mail == ""){
					alert("请输入电话号码，或者邮箱");
				}else{
					var url = this.baseUrl+"mail/send_mail";
					this.axios({
						// 默认请求方式为get
						method: 'get',
						url: url,
						// 传递参数
						params: {
							name: this.name,
							tel: this.tel,
							mail: this.mail,
							text:this.text,
						},
					}).then(response => {
						// 请求成功
						console.log(JSON.stringify(response));
						let res = response.data.msg;
						console.log(res);
						alert(res)
					}).catch(error => {
						// 请求失败，当then种出错就进入这里
						console.log("请求失败"+JSON.stringify(error));
						alert("请求失败");
					});
				}
			}
		}
	}
</script>

<style>
	.span{
		font-size: 30px;
		color: white;
	}
	.input{
		height: 40px;
		width: 350px;
		font-size: 30px;
	
	}
</style>
